import { useLocation } from "react-router-dom";
import RouterAuthorization from "./routerAuth/routerAuthorization";
import "bootstrap/dist/css/bootstrap.min.css";
import BillingProvider from "./components/Kitchen/billingProvider";
import Wrapper from "./wrapper";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import OutlineModal from "./components/outlet/outletModal";
import firebase from "./firebase";
import Notification from "./notification";
import CountryProvider from "./provider/courtryProvider";
import { Affix, ConfigProvider } from "antd";
import theme from "./theme.config.json";
import "./styles/antd.css";
import CounterProvider from "./provider/counterProvider";
import FooterDataProvider from "./provider/billingProviders/footerDataProvider";
import { ErrorBoundary } from "react-error-boundary";
import KOTBillingProvider from "./components/Kitchen/KOTbillingProvider";
import { App as AppAntd } from "antd";
import AccessProvider from "./provider/AccessProvider";
import CustomerDataProvider from "./provider/billingProviders/customerDataProvider";
import KoTDraftB2bProvider from "./components/Kitchen/KOT/kotDraftB2bProvider";
import DraftProvider from "./components/Kitchen/KOT/draftProvider";

function ErrorFallback() {
  return (
    <div
      style={{
        display: "grid",
        placeContent: "center",
        height: "100dvh",
        textAlign: "center",
        gap: 12,
      }}
    >
      <div>Something went wrong.</div>
      <button
        onClick={() => {
          //window.localStorage.clear();
          window.location.reload();
        }}
        style={{
          padding: "8px 20px",
          cursor: "pointer",
        }}
      >
        Reload
      </button>
    </div>
  );
}

function App() {
  const dispatch = useDispatch();
  const location = useLocation();

  const [width, setWidth] = useState(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const isMobile = width <= 768;

  useEffect(() => {
    var userType = window.localStorage.getItem("LOGIN_USERTYPE");
    if (userType) {
      dispatch({
        type: "SET_USERTYPE",
        payload: userType,
      });
    }
  }, []);

  // if (process.env.NODE_ENV === "production") {
  //   window.console.log = () => {};
  //   window.console.warn = () => {};
  // }

  if (isMobile) {
    return (
      <div
        style={{
          display: "grid",
          placeContent: "center",
          height: "100dvh",
          textAlign: "center",
        }}
      >
        Please log in via a desktop or laptop to use Ghoshak billing or
        <a href="https://play.google.com/store/apps/details?id=com.ghoshak_owner&hl=en&gl=US&pli=1">
          Download app
        </a>
      </div>
    );
  }

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      resetKeys={[location.pathname]}
      onError={(error, info) => {
        console.error(error);
        console.error(info.componentStack);
      }}
    >
      <AppAntd>
        <Wrapper>
          <KoTDraftB2bProvider>
            <AccessProvider>
              <ConfigProvider theme={theme}>
                <CountryProvider>
                  <BillingProvider>
                    <DraftProvider>
                      <KOTBillingProvider>
                        <CustomerDataProvider>
                          <FooterDataProvider>
                            <CounterProvider>
                              <RouterAuthorization />
                            </CounterProvider>
                          </FooterDataProvider>
                        </CustomerDataProvider>
                      </KOTBillingProvider>
                    </DraftProvider>
                  </BillingProvider>
                </CountryProvider>
              </ConfigProvider>
            </AccessProvider>
            {/* <Notification /> */}
          </KoTDraftB2bProvider>
        </Wrapper>
      </AppAntd>
    </ErrorBoundary>
  );
}

export default App;
